import React, { useState } from "react";
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { Save } from "@mui/icons-material";

export interface SaveSearchProps {
  loading?: boolean;
  disabled?: boolean;
  onClick: (title: string) => void;
}

const SaveSearch: React.FC<SaveSearchProps> = ({ loading, disabled, onClick }) => {
  const useButtonStyles = makeStyles(() => ({
    label: {
      whiteSpace: "nowrap",
    },
  }));
  const buttonStyles = useButtonStyles();

  const [open, setOpen] = useState(false);
  const [title, setTitle] = useState<string>("");

  const getDefaultTitle = () => {
    const now = new Date();
    const date = now.toLocaleDateString();
    const time = now.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
    return `Search ${date} ${time}`;
  };

  const handleClickOpen = () => {
    setTitle(getDefaultTitle());
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Button
        classes={buttonStyles}
        variant="outlined"
        onClick={handleClickOpen}
        disabled={disabled}
        startIcon={loading ? <CircularProgress size={20} thickness={6} /> : <Save />}
        data-testid="saveSearch"
      >
        Save Search
      </Button>
      <Dialog
        open={open}
        onClose={handleClose}
        PaperProps={{
          component: "form",
          onSubmit: (event: React.FormEvent<HTMLFormElement>) => {
            event.preventDefault();
            const trimmedTitle = title.trim() || getDefaultTitle();
            onClick(trimmedTitle);
            handleClose();
          },
        }}
      >
        <Box marginY={8}>
          <DialogTitle>Save search</DialogTitle>
          <DialogContent>
            <DialogContentText>Please enter a name for your search:</DialogContentText>
            <TextField
              autoFocus
              margin="dense"
              id="search-title"
              name="title"
              label=""
              type="text"
              value={title}
              onChange={event => setTitle(event.target.value)}
              fullWidth
              variant="outlined"
            />
          </DialogContent>
          <Box marginRight={8}>
            <DialogActions>
              <Button variant="outlined" onClick={handleClose}>
                Cancel
              </Button>
              <Button variant="contained" type="submit">
                Save
              </Button>
            </DialogActions>
          </Box>
        </Box>
      </Dialog>
    </>
  );
};

export default SaveSearch;
